<template>
	<div class="content">
		<ul class="nav nav-pills nav-pills-primary justify-content-center" role="tablist">
			<li class="nav-item">
				<a class="nav-link active" data-toggle="tab" href="#nav1-link1" role="tablist" aria-expanded="true">
					TRADING
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" data-toggle="tab" href="#nav1-link2" role="tablist" aria-expanded="false">
					ACCOUNT
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" data-toggle="tab" href="#nav1-link3" role="tablist" aria-expanded="false">
					PAYMENT
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" data-toggle="tab" href="#nav1-link6" role="tablist" aria-expanded="false">
					PASSWORD
				</a>
			</li>
		</ul>
		<div class="tab-content tab-space">
			<!-- Trading -->
			<div class="tab-pane active" id="nav1-link1" aria-expanded="true">
				<div class="row justify-content-center">
					<div class="col-md-4">
						<h4>GENERAL</h4>	
						<div class="form-group row">
							<label for="exampleFormControlSelect1" class="col-sm-4 col-form-label">MARKET</label>
							<div class="col-sm-8">
								<select class="custom-select c-select">
									<option value="1" disabled>GLOBAL</option>
									<option value="2" selected>INDONESIA</option>
									<!-- <option value="2">Foobar</option>
									<option value="3">Is great</option> -->
								</select>
							</div>
						</div>
						<hr>
						<h4>YOUR DETAILS</h4>
						<div class="form-group row">
							<label for="tradingFirstName" class="col-sm-4 col-form-label">FIRST NAME</label>
							<div class="col-sm-8">
								<input type="text" class="form-control-plaintext" id="tradingFirstName" v-model="trading.firstName" disabled>
							</div>
						</div>
						<div class="form-group row">
							<label for="tradingLastName" class="col-sm-4 col-form-label">LAST NAME</label>
							<div class="col-sm-8">
								<input type="text" class="form-control-plaintext" id="tradingLastName" v-model="trading.lastName" readonly>
							</div>
						</div>
						<div class="form-group row">
							<label for="tradingUsername" class="col-sm-4 col-form-label">USERNAME</label>
							<div class="col-sm-8">
								<input type="text" class="form-control-plaintext" id="tradingUsername" v-model="trading.username" readonly>
							</div>
						</div>
						<div class="form-group row">
							<label for="tradingEmail" class="col-sm-4 col-form-label">EMAIL</label>
							<div class="col-sm-8">
								<input type="email" class="form-control-plaintext" id="tradingEmail" v-model="trading.email" readonly>
							</div>
						</div>
					</div>
				</div>
				<div class="row justify-content-center text-center">
					<div class="col-md-6">
						<div class="alert alert-default" role="alert">
							<i class="tim-icons icon-alert-circle-exc"></i>&ensp;Please contact your brokerage firm to change your account details.
						</div>
					</div>
				</div>
				<br>
				<!-- <div class="row justify-content-center">
					<div class="col-auto">
						<button type="button" class="btn btn-success">UPDATE</button>
					</div>
				</div> -->
			</div>
			<!-- Account -->
			<div class="tab-pane" id="nav1-link2" aria-expanded="false">
				<div class="row justify-content-center">
					<div class="col-12 text-center">
						<div class="rounded c-balance p-3 mb-4" id="balance-usd">
							HIN: {{hin}}
						</div>
					</div>
				</div>
				<div class="row justify-content-center mb-4">
					<div class="col-md-6 mb-4 mb-md-0 vertical-line">
						<h4>CONTACT DETAILS</h4>
						<div class="form-group row">
							<label for="accountBusinessName" class="col-sm-4 col-form-label">BUSINESS NAME</label>
							<div class="col-sm-8">
								<input type="text" class="form-control-plaintext" id="accountBusinessName" style="color: white" v-model="account.businessName" readonly>
							</div>
						</div>
						<div class="form-group row">
							<label for="accountFirstName" class="col-sm-4 col-form-label">FIRST NAME</label>
							<div class="col-sm-8">
								<input type="text" class="form-control-plaintext" id="accountFirstName" v-model="account.firstName" readonly>
							</div>
						</div>
						<div class="form-group row">
							<label for="accountLastName" class="col-sm-4 col-form-label">LAST NAME</label>
							<div class="col-sm-8">
								<input type="text" class="form-control-plaintext" id="accountLastName" v-model="account.lastName" readonly>
							</div>
						</div>
						<div class="form-group row">
							<label for="accountEmail" class="col-sm-4 col-form-label">EMAIL</label>
							<div class="col-sm-8">
								<input type="email" class="form-control-plaintext" id="accountEmail" v-model="account.email" readonly>
							</div>
						</div>
						<div class="form-group row">
							<label for="accountPhoneNumber" class="col-sm-4 col-form-label">PHONE NUMBER</label>
							<div class="col-sm-8">
								<input type="text" class="form-control-plaintext" id="accountPhoneNumber" v-model="account.phoneNumber" readonly>
							</div>
						</div>
					</div>
					<div class="col-md-6">
						<h4>POSTAL ADDRESS</h4>
						<div class="form-group row">
							<label for="street" class="col-sm-4 col-form-label">STREET</label>
							<div class="col-sm-8">
								<input type="text" class="form-control-plaintext" id="street" v-model="account.street" readonly>
							</div>
						</div>
						<div class="form-group row">
							<label for="city" class="col-sm-4 col-form-label">CITY / SUBURB</label>
							<div class="col-sm-8">
								<input type="text" class="form-control-plaintext" id="city" v-model="account.city" readonly>
							</div>
						</div>
						<div class="form-group row">
							<label for="province" class="col-sm-4 col-form-label">STATE / PROVINCE</label>
							<div class="col-sm-8">
								<input type="text" class="form-control-plaintext" id="province"	v-model="account.province" readonly>
							</div>
						</div>
						<div class="form-group row">
							<label for="postCode" class="col-sm-4 col-form-label">POSTCODE</label>
							<div class="col-sm-8">
								<input type="text" class="form-control-plaintext" id="postCode"	v-model="account.postcode" readonly>
							</div>
						</div>
						<div class="form-group row">
							<label for="country" class="col-sm-4 col-form-label">COUNTRY</label>
							<div class="col-sm-8" v-if="account.country">
								<select class="selectpicker" data-size="2" data-style="btn btn-primary">
									<option selected>{{account.country}}</option>
									<!-- <option value="2">Foobar</option>
									<option value="3">Is great</option> -->
								</select>
							</div>
						</div>
					</div>
				</div>
				<div class="row justify-content-center">
					<div class="col-md-6 text-center">
						<div class="alert alert-default" role="alert">
							<i class="tim-icons icon-alert-circle-exc"></i>&ensp;Please contact your brokerage firm to change your account details.
						</div>
						<!-- <button type="button" class="btn btn-success">SEND REQUEST</button> -->
					</div>
				</div>
			</div>
			<!-- Payment -->
			<div class="tab-pane" id="nav1-link3" aria-expanded="false">
				<div class="row justify-content-center mb-3">
					<div class="col-12 text-center">
						<h4>BANK DETAILS</h4>
					</div>
				</div>
				<div v-if="paymentInfo" class="row mb-4">
					<div class="col-12 col-md-6 mb-4 mb-md-0 vertical-line">
						<h4 v-if="tradingType == 'kinesis'" class="text-center">COMMODITY ACCOUNT (APED) KAU</h4>
						<h4 v-else class="text-center">COMMODITY ACCOUNT (APED)</h4>
						<template v-if="tradingType == 'kinesis'">
							<div class="form-group row">
								<label for="paymentCommodityBankName" class="col-sm-4 col-form-label">BANK NAME</label>
								<div class="col-sm-8">
									<input type="text" class="form-control-plaintext" id="paymentCommodityBankName" placeholder="-" v-model="paymentInfo.rdk_kinesis.bank_name" disabled>
								</div>
							</div>
							<div class="form-group row">
								<label for="paymentCommodityAccountName" class="col-sm-4 col-form-label">ACCOUNT NAME</label>
								<div class="col-sm-8">
									<input type="text" class="form-control-plaintext" id="paymentCommodityAccountName" placeholder="-" v-model="paymentInfo.rdk_kinesis.account_name" disabled>
								</div>
							</div>
							<div class="form-group row">
								<label for="paymentCommodityAccountNumber" class="col-sm-4 col-form-label">ACCOUNT NUMBER</label>
								<div class="col-sm-8">
									<input type="text" class="form-control-plaintext" id="paymentCommodityAccountNumber" placeholder="-" v-model="paymentInfo.rdk_kinesis.account_number" disabled>
								</div>
							</div>
							<div class="form-group row">
								<label for="paymentCommodityCurrency" class="col-sm-4 col-form-label">CURRENCY</label>
								<div class="col-sm-8">
									<input type="text" class="form-control-plaintext" id="paymentCommodityCurrency" placeholder="-" v-model="paymentInfo.rdk_kinesis.currency" disabled>
								</div>
							</div>
							<div class="form-group row">
								<label for="paymentCommoditySwiftCode" class="col-sm-4 col-form-label">SWIFT CODE</label>
								<div class="col-sm-8">
									<input type="text" class="form-control-plaintext" id="paymentCommoditySwiftCode" placeholder="For costumers outside of Indonesia" v-model="paymentInfo.rdk_kinesis.swift_code" disabled>
								</div>
							</div>
							<div class="form-group row">
								<label for="paymentCommodityBankAddress" class="col-sm-4 col-form-label">BANK ADDRESS</label>
								<div class="col-sm-8">
									<input type="text" class="form-control-plaintext" id="paymentCommodityBankAddress" disabled>
								</div>
							</div>
						</template>
						<template v-else>
							<div class="form-group row">
								<label for="paymentCommodityBankName" class="col-sm-4 col-form-label">BANK NAME</label>
								<div class="col-sm-8">
									<input type="text" class="form-control-plaintext" id="paymentCommodityBankName" placeholder="-" v-model="paymentInfo.rdk_jgx.bank_name" disabled>
								</div>
							</div>
							<div class="form-group row">
								<label for="paymentCommodityAccountName" class="col-sm-4 col-form-label">ACCOUNT NAME</label>
								<div class="col-sm-8">
									<input type="text" class="form-control-plaintext" id="paymentCommodityAccountName" placeholder="-" v-model="paymentInfo.rdk_jgx.account_name" disabled>
								</div>
							</div>
							<div class="form-group row">
								<label for="paymentCommodityAccountNumber" class="col-sm-4 col-form-label">ACCOUNT NUMBER</label>
								<div class="col-sm-8">
									<input type="text" class="form-control-plaintext" id="paymentCommodityAccountNumber" placeholder="-" v-model="paymentInfo.rdk_jgx.account_number" disabled>
								</div>
							</div>
							<div class="form-group row">
								<label for="paymentCommodityCurrency" class="col-sm-4 col-form-label">CURRENCY</label>
								<div class="col-sm-8">
									<input type="text" class="form-control-plaintext" id="paymentCommodityCurrency" placeholder="-" v-model="paymentInfo.rdk_jgx.currency" disabled>
								</div>
							</div>
							<div class="form-group row">
								<label for="paymentCommoditySwiftCode" class="col-sm-4 col-form-label">SWIFT CODE</label>
								<div class="col-sm-8">
									<input type="text" class="form-control-plaintext" id="paymentCommoditySwiftCode" placeholder="For costumers outside of Indonesia" v-model="paymentInfo.rdk_jgx.swift_code" disabled>
								</div>
							</div>
							<div class="form-group row">
								<label for="paymentCommodityBankAddress" class="col-sm-4 col-form-label">BANK ADDRESS</label>
								<div class="col-sm-8">
									<input type="text" class="form-control-plaintext" id="paymentCommodityBankAddress" disabled>
								</div>
							</div>
						</template>
					</div>
					<div class="col-12 col-md-6">
						<h4 class="text-center">UTILITY ACCOUNT</h4>
						<div class="form-group row">
							<label for="paymentUtilityBankName" class="col-sm-4 col-form-label">INSTITUTION NAME</label>
							<div class="col-sm-8">
								<select class="custom-select" style="background-color: #1a1e34;" v-model="utilityAccountIndex">
								  <option v-for="(item, index) of paymentInfo.utility_account" :key="item.bank_name" :value="index">{{item.bank_name}}</option>
								</select>
							</div>
						</div>
						<div class="form-group row">
							<label for="paymentUtilityAccountName" class="col-sm-4 col-form-label">ACCOUNT NAME</label>
							<div class="col-sm-8">
								<input type="text" class="form-control-plaintext" id="paymentUtilityAccountName" placeholder="-"  v-model="paymentInfo.utility_account[utilityAccountIndex].account_name" disabled>
							</div>
						</div>
						<div class="form-group row">
							<label for="paymentUtilitySwiftCode" class="col-sm-4 col-form-label">SWIFT CODE</label>
							<div class="col-sm-8">
								<input type="text" class="form-control-plaintext" id="paymentUtilitySwiftCode" placeholder="For costumers outside of Indonesia" v-model="paymentInfo.utility_account[utilityAccountIndex].bank_code" disabled>
							</div>
						</div>
						<div class="form-group row">
							<label for="paymentUtilityBankAddress" class="col-sm-4 col-form-label">INSTITUTION ADDRESS</label>
							<div class="col-sm-8">
								<input type="text" class="form-control-plaintext" id="paymentUtilityBankAddress"  v-model="paymentInfo.utility_account[utilityAccountIndex].bank_address" disabled>
							</div>
						</div>
					</div>
				</div>
				<div class="row justify-content-center text-center">
					<div class="col-md-6">
						<div class="alert alert-default" role="alert">
							<i class="tim-icons icon-alert-circle-exc"></i>&ensp;Please contact your brokerage firm to change your account details.
						</div>
					</div>
				</div>
				<!-- <div class="row justify-content-center">
					<div class="col-12 col-md-5 text-center">
						<div class="form-group row">
							<label for="paymentInstitutionName" class="col-sm-4 col-form-label text-left">INSTITUTION NAME</label>
							<div class="col-sm-8">
								<input type="text" class="form-control-plaintext" id="paymentInstitutionName" >
							</div>
						</div>
						<div class="form-group row">
							<label for="paymentInstitutionAddress" class="col-sm-4 col-form-label text-left">INSTITUTION ADDRESS</label>
							<div class="col-sm-8">
								<input type="text" class="form-control-plaintext" id="paymentInstitutionAddress" >
							</div>
						</div>
					</div>
				</div> -->
			</div>
			<!-- Fees -->
			<div class="tab-pane" id="nav1-link4" aria-expanded="false">
				<div class="row justify-content-around">
					<div class="col-md-5">
						<h4>My Account Fees</h4>
						<ul class="nav nav-tabs justify-content-center" data-tabs="tabs">
							<li class="nav-item">
								<a class="nav-link active" href="#execution" data-toggle="tab">Execution Fees</a>
							</li>
							<li class="nav-item">
								<a class="nav-link" href="#storage" data-toggle="tab">Storage Fees</a>
							</li>
							<li class="nav-item">
								<a class="nav-link" href="#e-warrant" data-toggle="tab">E-Warrant Fees</a>
							</li>
						</ul>
						<div class="tab-content text-center">
							<div class="tab-pane active" id="execution">
								<div class="card text-left">
									<div class="card-body c-card-body">
										<p>FEE RATE (%)<span class="float-right" style="color: #1ebbe4;">1.00</span></p>
									</div>
								</div>
							</div>
							<div class="tab-pane" id="storage">
								<ul class="nav nav-pills justify-content-center nav-pills-icons" data-tabs="tabs">
									<li class="nav-item">
										<a class="nav-link active" href="#gold" data-toggle="tab">Gold</a>
									</li>
									<li class="nav-item">
										<a class="nav-link" href="#silver" data-toggle="tab">Silver</a>
									</li>
									<li class="nav-item">
										<a class="nav-link" href="#platinum" data-toggle="tab">Platinum</a>
									</li>
								</ul>
								<br>
								<div class="tab-content text-center">
									<div class="tab-pane active" id="gold">
										<div class="card text-left">
											<div class="card-body c-card-body">
												<p>FEE RATE (%)<span class="float-right" style="color: #1ebbe4;">1.00</span></p>
											</div>
										</div>
									</div>
									<div class="tab-pane" id="silver">
										<div class="card text-left">
											<div class="card-body c-card-body">
												<p>FEE RATE (%)<span class="float-right" style="color: #1ebbe4;">1.sd00</span></p>
											</div>
										</div>
									</div>
									<div class="tab-pane" id="platinum">
										<div class="card text-left">
											<div class="card-body c-card-body" style="padding: 15px 40px;">
												<p>FEE RATE (%)<span class="float-right" style="color: #1ebbe4;">1.00</span></p>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="tab-pane" id="e-warrant">
								<ul class="nav nav-pills justify-content-center nav-pills-icons" data-tabs="tabs">
									<li class="nav-item">
										<a class="nav-link active" href="#certification" data-toggle="tab">Certification</a>
									</li>
									<li class="nav-item">
										<a class="nav-link" href="#cancellation" data-toggle="tab">Cancellation</a>
									</li>
								</ul>
								<br>
								<div class="tab-content text-center">
									<div class="tab-pane active" id="certification">
										<h5>COST PER CONTRACT ($)</h5>
										<div class="card text-left" style="background-color: rgba(0,0,0,0);">
											<ul class="list-group list-group-flush">
												<li v-for="certification in certifications" :key="certification.id" class="list-group-item c-card-body" style="background-color: #27293d;">
													<p>{{certification.country}}<span class="float-right" style="color: #1ebbe4;">{{certification.total}}</span></p>
												</li>
											</ul>
										</div>
									</div>
									<div class="tab-pane" id="cancellation">
										<h5>COST PER CONTRACT ($)</h5>
										<div class="card text-left" style="background-color: rgba(0,0,0,0);">
											<ul class="list-group list-group-flush">
												<li v-for="cancellation in cancellations" :key="cancellation.id" class="list-group-item c-card-body" style="background-color: #27293d;">
													<p>{{cancellation.country}}<span class="float-right" style="color: #1ebbe4;">{{cancellation.total}}</span></p>
												</li>
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row justify-content-around">
					<div class="col-md-5">
						<h4>WITHDRAWAL FEES</h4>
						<div class="card text-left">
							<div class="card-body" style="min-height: 100px;">
								<p>Fees as agreed with your member/broker.</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- Tax -->
			<div class="tab-pane" id="nav1-link5" aria-expanded="false">
				<div class="row justify-content-center">
					<div class="col-md-4">
						<h4>MY ACCOUNT TAX RATE</h4>
						<div class="card text-left">
							<div class="card-body">
								<p>Tax Rate <span class="float-right">10.00%</span></p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- Security -->
			<div class="tab-pane" id="nav1-link6" aria-expanded="false">
				<div class="row justify-content-center mb-3">
					<div class="col-12 text-center">
						<h4>CHANGE PASSWORD</h4>
					</div>
				</div>
				<form @submit.prevent="changePasswordSubmit">
					<div class="row justify-content-center">
						<div class="col-11 text-center" style="max-width: 400px;">
							<div class="form-group row">
								<label for="oldPassword" class="col-12 col-form-label text-left">OLD PASSWORD</label>
								<div class="col-12">
									<input type="password" class="form-control" id="oldPassword" autocomplete="off" required v-model="oldPassword">
								</div>
							</div>
							<div class="form-group row">
								<label for="newPassword" class="col-12 col-form-label text-left">NEW PASSWORD</label>
								<div class="col-12">
									<input type="password" class="form-control" id="newPassword" autocomplete="off" required v-model="newPassword">
								</div>
							</div>
							<div class="form-group row">
								<label for="retypeNewPassword" class="col-12 col-form-label text-left">RETYPE NEW PASSWORD</label>
								<div class="col-12 text-left">
									<input type="password" class="form-control" id="retypeNewPassword" autocomplete="off" @click="retypePasswordValidation" @change="retypePasswordValidation" required v-model="retypeNewPassword">
									<code :style="{display: displayRetypeNewPasswordError}">Password doesn't match!</code>
								</div>
							</div>
							<!-- <button type="button" class="btn btn-success">UPDATE ACCOUNT</button> -->
						</div>
					</div>
					<!-- <div class="row justify-content-center">
						<div class="col-md-5">
							<h4>MULTIFACTOR AUTHENTICATION</h4>
							<div class="card text-left">
								<div class="card-body">
									<div class="row">
										<div class="col-2 align-self-center text-center">
											<i class="tim-icons icon-alert-circle-exc" style="font-size: 40px"></i>
										</div>
										<div class="col-10">
											<p>
												 Multifactor authentication requires the use of a supported third party mobile Authenticator App (e.g. Google Authenticator, Duo and Microsoft Authenticator) 
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div> -->
					<div class="row justify-content-center">
						<div class="col-md-5 text-center">
							<button type="submit" class="btn btn-warning">SUBMIT</button>
						</div>
					</div>
				</form>
				<div class="row justify-content-center text-center mt-5">
					<div class="col-md-6">
						<div class="alert alert-default" role="alert">
							<i class="tim-icons icon-alert-circle-exc"></i>&ensp;Your password in mobile app will also be replaced
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import Swal from 'sweetalert2'

	export default {
		name: 'Settings',
		data() {
			return {
				hin: this.$store.getters.getHin,
				certifications: [
					{ country: 'DUBAI', total: '25.00' },
					{ country: 'HONG KONG', total: '25.00' },
					{ country: 'LONDON', total: '12.00' },
					{ country: 'NEW YORK', total: '25.00' },
					{ country: 'SINGAPORE', total: '12.00' },
					{ country: 'SYDNEY', total: '12.00' },
					{ country: 'ZURICH', total: '25.00' }
				],
				cancellations: [
					{ country: 'DUBAI', total: '15.00' },
					{ country: 'HONG KONG', total: '15.00' },
					{ country: 'LONDON', total: '6.00' },
					{ country: 'NEW YORK', total: '15.00' },
					{ country: 'SINGAPORE', total: '6.00' },
					{ country: 'SYDNEY', total: '6.00' },
					{ country: 'ZURICH', total: '15.00' }
				],
				trading: {
					email: '-',
					firstName: '-',
					lastName: '-',
					username:'-',
				},
				account: {
					businessName: '-',
					firstName: '-',
					lastName: '-',
					email: '-',
					phoneNumber: '-',
					street: '-',
					city: '-',
					province: '-',
					postcode: '-',
					country: '-'
				},
				oldPassword: '',
				newPassword: '',
				retypeNewPassword: '',
				displayRetypeNewPasswordError: 'none',
				paymentInfo: null,
				utilityAccountIndex: 0,
			}
		},
		computed: {
			tradingType() {
				return this.$store.state.tradingType
			},
			utilityBankName: {
				get: function() {
					return this.utilityAccountIndex
				},
				set: function(val) {
					this.utilityAccountIndex == val
				}
			}
		},
		created() {
					axios({
						method: 'get',
						url:process.env.VUE_APP_BACKEND_URL+'/abx/trading_information'
					}).then(response => {
						let trading = response.data.data
						this.trading.email = trading.email
						this.trading.firstName = trading.firstName
						this.trading.lastName = trading.lastName
						this.trading.username = trading.username
						console.log('berhasil trading information', response)
					}).catch(error => {
						if (error.response) {
							/*
							 * The request was made and the server responded with a
							 * status code that falls out of the range of 2xx
							 */
							console.log(error.response.data);
							console.log(error.response.status);
							console.log(error.response.headers);
						} else if (error.request) {
							/*
							 * The request was made but no response was received, `error.request`
							 * is an instance of XMLHttpRequest in the browser and an instance
							 * of http.ClientRequest in Node.js
							 */
							console.log(error.request);
						} else {
							// Something happened in setting up the request and triggered an Error
							console.log(error.message);
						}
						console.log('gagal trading information', error.config);
					})

					axios({
						method: 'get',
						url:process.env.VUE_APP_BACKEND_URL+'/abx/account_information'
					}).then(response => {
						let account = response.data.data
						this.account.businessName = ''
						this.account.firstName = account.firstName
						this.account.lastName = account.lastName
						this.account.email = account.email
						this.account.phoneNumber = account.phoneNumber
						this.account.street = account.street
						this.account.city = account.city
						this.account.province = account.province
						this.account.postcode = account.postcode
						this.account.country = account.country
						console.log('berhasil account information', response)
					}).catch(error => {
						if (error.response) {
							/*
							 * The request was made and the server responded with a
							 * status code that falls out of the range of 2xx
							 */
							console.log(error.response.data);
							console.log(error.response.status);
							console.log(error.response.headers);
						} else if (error.request) {
							/*
							 * The request was made but no response was received, `error.request`
							 * is an instance of XMLHttpRequest in the browser and an instance
							 * of http.ClientRequest in Node.js
							 */
							console.log(error.request);
						} else {
							// Something happened in setting up the request and triggered an Error
							console.log(error.message);
						}
						console.log('gagal account information', error.config);
					})
			

			axios({
				method: 'get',
				url:process.env.VUE_APP_BACKEND_URL+'/abx/payment_information'
			}).then(response => {
				this.paymentInfo = response.data.data
				console.log('berhasil payment information', response)
			}).catch(error => {
				if (error.response) {
					/*
					 * The request was made and the server responded with a
					 * status code that falls out of the range of 2xx
					 */
					console.log(error.response.data);
					console.log(error.response.status);
					console.log(error.response.headers);
				} else if (error.request) {
					/*
					 * The request was made but no response was received, `error.request`
					 * is an instance of XMLHttpRequest in the browser and an instance
					 * of http.ClientRequest in Node.js
					 */
					console.log(error.request);
				} else {
					// Something happened in setting up the request and triggered an Error
					console.log(error.message);
				}
				console.log('gagal payment information', error.config);
			})
		},
		mounted() {
			console.log('MOUNTED')
		},
		methods: {
			changePasswordSubmit() {
				if (this.newPassword != this.retypeNewPassword) {
					this.displayRetypeNewPasswordError = 'initial'
				}else {
					Swal.fire({
						background: '#191f31',
						title: '<span style="color: white;">Are you sure want to change your password?</span>',
						imageWidth: 50,
						imageHeight: 50,
						showCancelButton: true,
						confirmButtonColor: '#3085d6',
						cancelButtonColor: '#d33',
						confirmButtonText: 'Yes'
					}).then((result) => {
						if (result.value) {
							// http://34.87.103.204:80/v1/abx/change_password
							axios({
								method: 'post',
								url: process.env.VUE_APP_BACKEND_URL+'/abx/change_password',
								data: {
									password: this.oldPassword,
									new_password: this.newPassword
								}
							}).then(response => {
						    this.oldPassword = ''
						    this.newPassword = ''
						    this.retypeNewPassword = ''
								Swal.fire({
						      background: '#191f31',
						      type: 'success',
						      title: '<span style="color: white;">Changed!</span>',
						      html: '<span style="color: white;">Your password has been changed.</span>'
						    })
								console.log('berhasil change password', response)
							}).catch(error => {
								let err = error.response.data
								Swal.fire({
									background: '#191f31',
						      type: 'error',
						      title: '<span style="color: white;">Failed!</span>',
						      html: `<span style="color: white;">${err.message}</span>`
						    })
								console.log("gagal change_password", error.response)
							})
						}
					})
				}
			},
			retypePasswordValidation() {
				// if (this.newPassword != this.retypeNewPassword) {
				// }else {
				// 	return 'initial'
				// }
				this.displayRetypeNewPasswordError = 'none'
			}
		}
	}
</script>

<style scoped>
	.c-card-body {
		padding: 15px 40px;
	}
	.c-card-multiple {
		margin: 0px;
	}

	div.card li {
		padding: 5px 40px;
		padding-top: 10px;
		border: 0px;
		margin: 1px ;
		border-radius: 7px;
	}

	.c-balance {
		background-color: #2e3d61;
		display: inline-block;
		color: white;
	}
	.vertical-line {
		/*border-left: 2px solid white;*/
		border-right: 1px solid white;
	}
	@media only screen and (max-width: 768px) {
		.vertical-line {
		/*border-left: 2px solid white;*/
		border-right: 0;
		border-bottom: 1px solid white;
	}
	}
</style>